export default __webpack_public_path__ + "static/media/expand.5228fee3.svg";